export default __webpack_public_path__ + "static/media/bg4.67bbd0ac.jpg";